<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"><a id="ch00_fm03_copy"></a><a id="page_iv"></a>NEW YORK UNIVERSITY PRESS<br/>New York and London<br/><span class="weblink"><a class="nounder" href="http://www.nyupress.org" target="_blank">www.nyupress.org</a></span></p>
<p class="noindent1">© 2012 by New York University<br/>All rights reserved</p>
<p class="noindent1">Published with the support of Dr. Sigmund Stahl</p>
<p class="noindent1">References to Internet websites (URLs) were accurate at the time of writing. Neither the author nor New York University Press is responsible for URLs that may have expired or changed since the manuscript was prepared.</p>
<p class="noindent1">Library of Congress Cataloging-in-Publication Data<br/>Swartz, Michael D.<br/>The signifying creator : nontextual sources of meaning in ancient<br/>Judaism / Michael D. Swartz.<br/>p. cm.<br/>Includes bibliographical references and index.<br/>ISBN 978-0-8147-4093-4 (cl : alk. paper) — ISBN 978-0-8147-2378-4 (ebook) — ISBN 978-0-8147-0811-8 (ebook)<br/>1. Jewish mythology. 2. Jewish legends. 3. Symbolism in rabbinical literature. 4. Jewish art and symbolism. 5. Semiotics — Religious aspects — Judaism. 6. Judaism — History — Post-exilic period, 586<br/>B.C.-210 A.D. I. Title.<br/>BM530.S88 2012<br/>296.3 — dc23      2011043493<br/>New York University Press books are printed on acid-free paper, and their binding materials are chosen for strength and durability. We strive to use environmentally responsible suppliers and materials to the greatest extent possible in publishing our books.</p>
<p class="noindent1">Manufactured in the United States of America</p>
<p class="noindent1">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_copy.vue?7a3e34b0